import { combineReducers } from '@reduxjs/toolkit';
import { commonRootReducer } from '@pec/aion-ui-core/combineReducers';
import hiringClientReducer from '../reducers/hiringClient.reducer';
import companyDataReducer from 'reducers/companyData.reducer';
import orderReducer from 'reducers/order.reducer';
import validationReducer from 'reducers/validation.reducer';
import locationDataReducer from '../reducers/locationData.reducer';
import paymentReducer from '../reducers/payment.reducer';
import errorCatcherReducer from '../reducers/errorCatcher.reducer';
import specialPriceReducer from '../reducers/specialPrice.reducer';
import countryConfigReducer from '../reducers/countryConfig.reducer';
import companySearchReducer from '../reducers/companySearch.reducer';

// @ts-ignore - circular type reference in ISubsidiariesOrganization from commonRootReducer
export const rootReducer = combineReducers({
  ...commonRootReducer,
  locationData: locationDataReducer,
  companyData: companyDataReducer,
  validation: validationReducer,
  payment: paymentReducer,
  order: orderReducer,
  error: errorCatcherReducer,
  hiringClient: hiringClientReducer,
  specialPrice: specialPriceReducer,
  countryConfig: countryConfigReducer,
  companySearch: companySearchReducer
});
export type RootState = ReturnType<typeof rootReducer>;
